import { useAuth } from '../contexts/AuthContext';

/**
 * Hook that provides auth readiness state for gating data fetches
 * 
 * Returns:
 * - ready: boolean - true when auth check is complete (user authenticated or not)
 * - user: object|false|null - the authenticated user, false if not authenticated, null if loading
 * - loading: boolean - true while auth check is in progress
 * 
 * Usage:
 * const { ready, user } = useAuthReady();
 * 
 * useEffect(() => {
 *   if (!ready) return; // Wait for auth to be established
 *   if (!user) return; // User not authenticated
 *   
 *   // Safe to fetch protected data here
 *   fetchProtectedData();
 * }, [ready, user]);
 */
export const useAuthReady = () => {
  const { user, loading, ready } = useAuth();
  
  return {
    ready: ready && !loading,
    user,
    loading
  };
};
